// Plan-based feature gating (Solo / Équipe / Entreprise).
// Retro-compatible: if kallitag.fr does not send `plan` yet, access stays full.
export const PLAN_RANK = { solo: 1, equipe: 2, entreprise: 3 };
export const FEATURE_MIN_PLAN = {
  crm_sync: "equipe",
  team: "equipe",
  archiving: "entreprise",
  comparator: "entreprise",
  account_summary: "entreprise",
};
const LABEL = { solo: "Solo", equipe: "Équipe", entreprise: "Entreprise" };
export const UPGRADE_URL = "/abonnement";

export function normalizePlan(v) {
  const p = String(v || "").trim().toLowerCase();
  return PLAN_RANK[p] ? p : null;
}

export function planAllows(user, feature) {
  if (user?.isPlatformAdmin) return true; // super-admins: everything unlocked
  const plan = normalizePlan(user?.plan);
  if (!plan) return true; // kallitag.fr not yet sending plan -> keep full access
  const need = PLAN_RANK[FEATURE_MIN_PLAN[feature] || "solo"] || 1;
  return PLAN_RANK[plan] >= need;
}

export function requiredTier(feature) {
  return LABEL[FEATURE_MIN_PLAN[feature]] || "supérieur";
}
